export const METADATA_BULK_LINE_ITEM = 'mwcIsBulk'

// Determines whether or not the items in a cart were added on the bulk page.
export const getDoesCartHaveBulkItems = (lineItems) =>
  !!lineItems?.filter(
    (lineItem) => !!lineItem?.metadata?.[METADATA_BULK_LINE_ITEM]
  ).length > 0
